export default "__VITE_ASSET__Gf3mrPJ5__"